"use client";
import { useModalBaseContext } from "./ModalBase.context.mjs";
import { useEffect } from "react";
//#region packages/@mantine/core/src/components/ModalBase/use-modal-body-id.ts
function useModalBodyId() {
	const ctx = useModalBaseContext();
	useEffect(() => {
		ctx.setBodyMounted(true);
		return () => ctx.setBodyMounted(false);
	}, []);
	return ctx.getBodyId();
}
//#endregion
export { useModalBodyId };

//# sourceMappingURL=use-modal-body-id.mjs.map